import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalsService } from './globals.service';
import { BaseProvider } from './base-provider';
@Injectable({providedIn: 'root'})
export class ProfileTypeService extends BaseProvider {
  constructor(private http: HttpClient, private globals: GlobalsService) {
    super();
    this.baseUrl = 'profileType';
  }

  getProfileTypes() {
    return this.http.get(this.globals.dataUrl + this.baseUrl);
  }

}